import { FC } from 'react'
import styled from '@emotion/styled'
import { HeaderCover, HeaderCoverProps } from 'src/v2/components/sidebar-header-cover'
import { HeaderContentLoading } from 'src/v2/components/sidebar-header-content'
import { Colors } from 'src/components/theme'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${Colors.border};
`

type SidebarHeaderLoadingProps = Pick<HeaderCoverProps, 'icon' | 'iconBackground' | 'iconBorderColor' | 'image'>

export const SidebarHeaderLoading: FC<SidebarHeaderLoadingProps> = ({
  image,
  icon,
  iconBackground,
  iconBorderColor,
}) => {
  return (
    <Wrapper>
      <HeaderCover icon={icon} iconBackground={iconBackground} iconBorderColor={iconBorderColor} image={image} />
      <HeaderContentLoading />
    </Wrapper>
  )
}

type SidebarHeaderProps = {
  cover: React.ReactNode
  content: React.ReactNode
}

export const SidebarHeader: FC<SidebarHeaderProps> = ({ content, cover }) => {
  return (
    <Wrapper>
      {cover}
      {content}
    </Wrapper>
  )
}
